import React, {useEffect} from 'react';
import {Link, Route, Switch, Redirect, NavLink, withRouter} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {ListItem, List, Icon} from "@material-ui/core";
import {LineStyle, Layers} from "@material-ui/icons";

import Header from "components/Header/Header";
import Button from "components/CustomButtons/Button";
import CustomDropdown from "components/CustomDropdown/CustomDropdown";


import NavBarStyle from "./NavBarStyle";
import Email from "@material-ui/icons/Email";


const useStyles = makeStyles(NavBarStyle);

const NavBar = (props) => {
    const classes = useStyles();

    const headerColorChange = () => {
        const windowsScrollTop = window.pageYOffset;
        if (windowsScrollTop > 80) {
            document.body
                .getElementsByTagName("header")[0]
                .classList.remove(classes.dark);
            document.body
                .getElementsByTagName("header")[0]
                .classList.add(classes.dark);
        } else {
            document.body
                .getElementsByTagName("header")[0]
                .classList.add(classes.dark);
            document.body
                .getElementsByTagName("header")[0]
                .classList.remove(classes.dark);
        }
    };


    return (
        <Header
            fixed
            brand={<img className={classes.logo} src={require('assets/img/logo1.png')} alt="Logo" />}
            color={"white"}
            links={
                <List className={classes.list + " " + classes.mlAuto}>
                    <NavLink to="/reservation">
                        <ListItem className={classes.listItem}>
                            <Button
                                className={classes.navLink}
                                color="transparent"
                            >
                                RESERVATION
                            </Button>
                        </ListItem>
                    </NavLink>
                    <NavLink to="/">
                        <ListItem className={classes.listItem}>
                            <Button
                                className={classes.navLink}
                                color="transparent"
                            >
                                About Us
                            </Button>
                        </ListItem>
                    </NavLink>
                    <NavLink to="/contact">
                        <ListItem className={classes.listItem}>
                            <Button
                                href="#pablo"
                                className={classes.navLink}
                                color="transparent"
                            >
                                <span style={{color: 'black'}}>Contact</span>
                            </Button>
                        </ListItem>
                    </NavLink>
                </List>
            }
        />
    );
};

export default withRouter(NavBar);
